import { ChevronDownIcon } from "@heroicons/react/24/outline";

export const ChevronIcon = () => (
  <span className="p-1 rounded-full text-black opacity-70 bg-neutral-100">
    <ChevronDownIcon className="w-6 h-6" />
  </span>
);
